import {
  ANALYTICS_RESET_REDUX,
  ANALYTICS_RESET_MODULE,
  ANALYTICS_TOGGLE_LOADING,
  ANALYTICS_TOGGLE_DATASETS,
  ANALYTICS_UPDATE_FIELD_VALUE,
  ANALYTICS_UPDATE_DATASETS_FIELD_VALUE
} from '../actions/analytics.actions'

const initState = {
  analyticsCurriculum: {
    loading: true,
    datasets: {}
  }
}

const analyticsReducer = (state = initState, action) => {
  const { type, payload } = action
  const newState = { ...state }
  switch (type) {
    case ANALYTICS_RESET_REDUX:
      return JSON.parse(JSON.stringify({ ...initState }))
    case ANALYTICS_RESET_MODULE:
      newState[payload.module] = JSON.parse(JSON.stringify({ ...initState[payload.module] }))
      break
    case ANALYTICS_TOGGLE_LOADING:
      newState[payload.module].loading = payload.loading
      break
    case ANALYTICS_TOGGLE_DATASETS:
      newState[payload.module].datasets = payload.datasets
      break
    case ANALYTICS_UPDATE_FIELD_VALUE:
      newState[payload.module][payload.field] = payload.value
      break
    case ANALYTICS_UPDATE_DATASETS_FIELD_VALUE:
      newState[payload.module].datasets[payload.field] = payload.value
      break
    default:
      break
  }

  return newState
}

export default analyticsReducer
